import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "id", "as", "children"],
    _excluded2 = ["title", "hasSeparator", "items", "as", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, Children, cloneElement } from 'react';
import cx from 'classnames';
import { prefix } from '../../tools/settings';
import { StyledNavigation, StyledNavigationSection, StyledNavigationTitle, StyledNavigationItem, StyledNavigationLink, StyledNavigationList, StyledNavigationIcon, StyledNavigationArrowInput, StyledNavigationArrowLabel, StyledNavigationArrowIcon } from './Navigation.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var Navigation = forwardRef(function (_ref, ref) {
  var _cx;

  var customClassName = _ref.className,
      id = _ref.id,
      as = _ref.as,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-navigation"), true), _defineProperty(_cx, customClassName, !!customClassName), _cx));
  var childrens = Children.map(children, function (child) {
    return cloneElement(child, {
      as: as
    });
  });
  return _jsx(StyledNavigation, _objectSpread(_objectSpread({
    ref: ref,
    className: className
  }, rest), {}, {
    children: childrens
  }));
});

var NavigationSection = function NavigationSection(_ref2) {
  var title = _ref2.title,
      hasSeparator = _ref2.hasSeparator,
      items = _ref2.items,
      as = _ref2.as,
      customClassName = _ref2.className,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  return _jsxs(StyledNavigationSection, {
    "data-separator": hasSeparator,
    children: [title && _jsx(StyledNavigationTitle, {
      children: title
    }), _jsx(StyledNavigationList, {
      children: items.map(function (item, groupIdx) {
        return _jsxs(StyledNavigationItem, {
          children: [_jsxs(StyledNavigationLink, _objectSpread(_objectSpread({
            as: as || item.as,
            to: item.url,
            end: item.exact || item.isExact,
            exact: item.exact || item.isExact,
            href: item.url,
            id: "navigation-group-section-".concat(groupIdx),
            onClick: item.onClick,
            activeClassName: "selected sublist--open",
            className: item.isSelected && 'selected sublist--open',
            "aria-disabled": item.isDisabled
          }, rest), {}, {
            children: [item.icon && _jsx(StyledNavigationIcon, {
              icon: item.icon
            }), item.label, !isNaN(item.count) && _jsxs("small", {
              children: ["(", item.count > 0 ? item.count : 0, ")"]
            })]
          })), item.items && _jsxs(_Fragment, {
            children: [_jsx(StyledNavigationArrowInput, {
              name: "navigation-group-".concat(groupIdx),
              id: "navigation-group-".concat(groupIdx),
              defaultChecked: item.isSelected || item.items.some(function (subitem) {
                return subitem.isSelected === true;
              }),
              onChange: function onChange() {
                var checkbox = document.getElementById("navigation-group-".concat(groupIdx));
                var group = document.getElementById("navigation-group-section-".concat(groupIdx)).classList;

                if (group.contains('sublist--open') || group.contains('selected')) {
                  group.toggle('sublist--open');
                  checkbox.checked = false;
                }
              }
            }), _jsx(StyledNavigationArrowLabel, {
              htmlFor: "navigation-group-".concat(groupIdx),
              children: _jsx(StyledNavigationArrowIcon, {})
            })]
          }), item.items && _jsx(StyledNavigationList, {
            className: "".concat(prefix, "-navigation__sublist"),
            children: item.items.map(function (subItem, i) {
              var _cx2;

              return _jsx(StyledNavigationItem, {
                children: _jsxs(StyledNavigationLink, _objectSpread(_objectSpread({
                  as: as || subItem.as,
                  to: subItem.url,
                  end: subItem.exact || subItem.isExact,
                  exact: subItem.exact || subItem.isExact,
                  href: subItem.url,
                  onClick: subItem.onClick,
                  onMouseUp: function onMouseUp() {
                    var checkbox = document.getElementById("navigation-group-".concat(groupIdx));
                    checkbox.checked = true;
                  },
                  activeClassName: "selected",
                  className: cx((_cx2 = {}, _defineProperty(_cx2, "subitem", true), _defineProperty(_cx2, "selected", subItem.isSelected), _cx2)),
                  "aria-disabled": subItem.isDisabled
                }, rest), {}, {
                  children: [subItem.icon && _jsx(StyledNavigationIcon, {
                    icon: subItem.icon
                  }), subItem.label, !isNaN(subItem.count) && _jsxs("small", {
                    children: ["(", subItem.count > 0 ? subItem.count : 0, ")"]
                  })]
                }))
              }, i);
            })
          })]
        }, groupIdx);
      })
    })]
  });
};

Navigation.Section = NavigationSection;
export default Navigation;